export default __webpack_public_path__ + "static/media/gesture-two-finger-drag.2ed2f853.svg";